import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "../mui";
import { Lock } from "@mui/icons-material";
import { ContentTypography } from "../common/content";
const BottomFooter = () => (_jsxs(Grid, { container: true, alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { item: true, children: _jsx(Lock, { sx: { pt: 1 }, size: "small" }) }), _jsx(Grid, { item: true, children: _jsx(ContentTypography, { field: "bottomFooterLabel" }) })] }));
export default BottomFooter;
